var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12,24A12,12,0,1,1,24,12,12.014,12.014,0,0,1,12,24ZM12,13.08c-2.425,0-7.164,1.3-7.2,3.7a8.64,8.64,0,0,0,14.4,0c-.011-.738-.491-1.813-2.718-2.744A12.838,12.838,0,0,0,12,13.08ZM12,3.6a3.6,3.6,0,1,0,3.6,3.6A3.6,3.6,0,0,0,12,3.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconName);
export default __webpack_public_path__ + "static/media/icon-name.0f41cf5d79111ca9a96f7fc55821d094.svg";
export { ForwardRef as ReactComponent };